export default "__VITE_ASSET__Chw97qgm__"